import angular from 'angular';
import $ from 'jquery';

export default class ProductBrands {
  constructor($scope, ProductService, PaginationService) {
    $scope.set_selected_tab = function (index) {
      $scope.selected_tab = index;
    };

    $scope.quick_search = function (table, query) {
      if (query)
        window.filter_table(table, query);
    };

    $scope.get_brands = function (filter) {
      filter.searching = true;
      ProductService.get_brand_data(filter).then(function (data) {
        if (filter.is_specified == 'yes')
          $scope.specified_brands = data.brands;
        else
          $scope.unspecified_brands = data.brands;
        filter.pagination = PaginationService.get_pagination(data.pagination);
        filter.searching = false;
      });
    };

    $scope.get_page_data = function (filter, page) {
      filter.page = page;
      $scope.get_brands(filter);
    };

    $scope.init_specified_filter = function () {
      $scope.specified_filter = {
        page: 1,
        per_page: 50,
        category_id: null,
        group_id: null,
        has_end_uses: 'All',
        is_specified: 'yes',
        searching: false,
        is_visible_website: false,
        has_description: 'All',
        has_short_description: 'All'
      };
    };

    $scope.init_unspecified_filter = function () {
      $scope.unspecified_filter = {
        page: 1,
        per_page: 50,
        category_id: null,
        group_id: null,
        has_end_uses: 'All',
        is_specified: 'no',
        searching: false,
        is_visible_website: false,
        has_description: 'All',
        has_short_description: 'All'
      };
    };

    $scope.init_jquery_calls = function () {
      $(document).on('click', 'a.delete_brand', function (e) {
        if (!confirm('Are you sure you want to delete this Brand?')) {
          e.preventDefault();
        }
      });
      $('a#add_brands').click(function (e) {
        e.preventDefault();
        $.fancybox($('div#add_brands_dialog'), {
          padding: '5',
          scrolling: 'no',
          openEffect: 'elastic',
          closeEffect: 'elastic',
          openSpeed: '700',
          closeSpeed: '300',
          topRatio: 0.15
        });
      });
      window.set_product_brand_mill_autocomplete($('input.mill'));
      $('button#add_brand_row').click(function (e) {
        e.preventDefault();
        var table = $(this).parents('table');
        var row = table.find('tbody tr').last();
        var clone = row.clone();
        clone.find('input, select:eq(0)').each(function () {
          $(this).val('').attr('name', $(this).attr('name').replace(/\d+/, function (n) {
            return ++n;
          }));
        });
        clone.find('select:gt(0)').each(function () {
          $(this).val('').attr('name', $(this).attr('name').replace(/\d+/, function (n) {
            return ++n;
          }));
          $(this).find('option:gt(0)').remove();
        });
        window.set_product_brand_mill_autocomplete(clone.find('input.mill'));
        table.find('tbody').append(clone);
      });
      $(document).on('change', 'select.category', function () {
        window.get_groups_by_category($(this).parent().next().find('select'), $(this).val());
      });
      $(document).on('change', 'select.group', function () {
        window.get_products_by_group_for_select($(this).parent().next().find('select'), $(this).val());
      });
      $('a.match_item_brand, a.match_user_brand').click(function (e) {
        e.preventDefault();
        var dialog = $('#match_brand_dialog');
        var brand = $.trim($(this).parents('tr').find('td:eq(0)').html());
        dialog.find('span.source_brand').html(brand);
        if ($(this).hasClass('match_item_brand')) {
          dialog.find('input[name="source_item_brand"]').val(brand);
          dialog.find('input[name="source_user_brand"]').val('');
        } else {
          dialog.find('input[name="source_item_brand"]').val('');
          dialog.find('input[name="source_user_brand"]').val($(this).data('brand_id'));
        }
        window.openFancyboxDialog('#match_brand_dialog');
      });
      $('form#match_brand_form').submit(function (e) {
        if ($(this).find('select#brand_id').val() == '') {
          e.preventDefault();
          alert('Please select the target Brand!');
        }
      });
    };

    $scope.init = function () {
      $scope.selected_tab = 0;
      $scope.init_specified_filter();
      $scope.init_unspecified_filter();
      $scope.specified_categories = angular.copy(window.categories);
      $scope.speficied_groups = angular.copy(window.groups);
      $scope.unspecified_categories = angular.copy(window.categories);
      $scope.unspeficied_groups = angular.copy(window.groups);
      $scope.get_brands($scope.specified_filter);
      $scope.get_brands($scope.unspecified_filter);
      $scope.init_jquery_calls();
    };

    $scope.init();
  }
}

ProductBrands.$inject = ['$scope', 'ProductService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-brands.ctrl.js